import request from './../utils/request'


export function index(params) {
  	return request({
  	  url: '/discounts',
  	  method: 'get',
        params
  	})
  }
  
export function show(id) {
    return request({
      url: `/discounts/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/discounts',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/discounts/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/discounts/${id}`,
      method: 'delete',
    })
  }

  